/* ======================================================================
   KOPI BLOK — Custom interactions
   Vanilla JS — no dependencies. Defensive; re-queries on each init.
   ====================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1) Fade-in on scroll (IntersectionObserver)
  ------------------------------------------------------------------ */
  function initFadeIn() {
    var els = document.querySelectorAll('.kb-fade-in:not(.kb-visible)');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('kb-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------
     2) Hero carousel (autoplay + dots + RTL-aware)
  ------------------------------------------------------------------ */
  function initHero(section) {
    var track = section.querySelector('[data-kb-hero-track]');
    var slides = section.querySelectorAll('[data-kb-hero-slide]');
    var dots = section.querySelectorAll('[data-kb-hero-dot]');
    if (!track || slides.length < 2) return;

    var index = 0;
    var count = slides.length;
    var delay = parseInt(section.dataset.autoplay || '5000', 10);
    var timer = null;

    function go(to) {
      index = (to + count) % count;
      track.style.transform = 'translateX(' + (index * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('kb-active', i === index);
      });
    }
    function next() { go(index + 1); }

    function start() { stop(); timer = setInterval(next, delay); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); start(); });
    });
    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);

    go(0);
    start();
  }

  /* ------------------------------------------------------------------
     3) Featured-products / Testimonials / Instagram horizontal scroller
  ------------------------------------------------------------------ */
  function initScroller(section) {
    var scrollEl = section.querySelector('[data-kb-scroll]');
    if (!scrollEl) return;
    var prevBtn = section.querySelector('[data-kb-scroll-prev]');
    var nextBtn = section.querySelector('[data-kb-scroll-next]');
    var amount = parseInt(section.dataset.scrollAmount || '320', 10);

    function scrollBy(dir) {
      scrollEl.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollBy(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollBy(1); });
  }

  /* ------------------------------------------------------------------
     4) Testimonials paged carousel (4-up desktop / 1-up mobile)
  ------------------------------------------------------------------ */
  function initTestimonials(section) {
    var track = section.querySelector('[data-kb-tst-track]');
    var cards = section.querySelectorAll('[data-kb-tst-card]');
    var prevBtn = section.querySelector('[data-kb-tst-prev]');
    var nextBtn = section.querySelector('[data-kb-tst-next]');
    if (!track || !cards.length) return;

    var total = cards.length;
    var page = 0;

    function visible() { return window.innerWidth >= 768 ? 4 : 1; }
    function maxPage() { return Math.max(0, total - visible()); }

    function render() {
      var v = visible();
      cards.forEach(function (c) {
        c.style.flexBasis = (v === 4 ? 'calc((100% - 60px) / 4)' : '100%');
      });
      if (page > maxPage()) page = maxPage();
      var offset = page * (100 / v);
      track.style.transform = 'translateX(' + offset + '%)';
      if (prevBtn) prevBtn.disabled = page <= 0;
      if (nextBtn) nextBtn.disabled = page >= maxPage();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { page = Math.max(0, page - 1); render(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { page = Math.min(maxPage(), page + 1); render(); });
    window.addEventListener('resize', render);
    render();
  }

  /* ------------------------------------------------------------------
     5) Product gallery (main image + thumbnails + prev/next)
  ------------------------------------------------------------------ */
  function initGallery(section) {
    var mainImg = section.querySelector('[data-kb-main-img]');
    var thumbs = section.querySelectorAll('[data-kb-thumb]');
    var prevBtn = section.querySelector('[data-kb-gal-prev]');
    var nextBtn = section.querySelector('[data-kb-gal-next]');
    if (!mainImg || thumbs.length < 2) return;

    var index = 0;
    function go(i) {
      index = (i + thumbs.length) % thumbs.length;
      var thumb = thumbs[index];
      var src = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
      var alt = thumb.querySelector('img').alt || '';
      mainImg.src = src;
      mainImg.alt = alt;
      thumbs.forEach(function (t, j) { t.classList.toggle('kb-thumb-active', j === index); });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });
    go(0);
  }

  /* ------------------------------------------------------------------
     6) Product configurator (4-step form)
  ------------------------------------------------------------------ */
  function initConfigurator(section) {
    var form = section.querySelector('[data-kb-configurator]');
    if (!form) return;

    var groups = section.querySelectorAll('[data-kb-pillgroup]');
    groups.forEach(function (group) {
      var inputName = group.dataset.kbPillgroup;
      var hidden = form.querySelector('input[name="' + inputName + '"]');
      var pills = group.querySelectorAll('[data-kb-pill]');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('kb-pill-active'); });
          pill.classList.add('kb-pill-active');
          if (hidden) hidden.value = pill.dataset.value;
          updateTotal(section);
        });
      });
    });

    var qtyInput = form.querySelector('[data-kb-qty]');
    var qtyMinus = form.querySelector('[data-kb-qty-minus]');
    var qtyPlus = form.querySelector('[data-kb-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v - 1);
        updateTotal(section);
      });
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
        updateTotal(section);
      });
    }

    var variantSelect = form.querySelector('[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () { updateTotal(section); });
    }
    form.querySelectorAll('[data-kb-variant-pill]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-kb-variant-group]');
        if (!group) return;
        group.querySelectorAll('[data-kb-variant-pill]').forEach(function (b) { b.classList.remove('kb-pill-active'); });
        btn.classList.add('kb-pill-active');
        syncVariantFromPills(section);
      });
    });

    syncVariantFromPills(section);
    updateTotal(section);
  }

  function syncVariantFromPills(section) {
    var form = section.querySelector('[data-kb-configurator]');
    if (!form) return;
    var variantInput = form.querySelector('input[name="id"]');
    var dataEl = section.querySelector('[data-kb-variants]');
    if (!variantInput || !dataEl) return;

    var selected = {};
    section.querySelectorAll('[data-kb-variant-group]').forEach(function (group) {
      var name = group.dataset.optionName;
      var active = group.querySelector('.kb-pill-active');
      if (name && active) selected[name] = active.dataset.value;
    });

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var match = variants.find(function (v) {
      return Object.keys(selected).every(function (k) { return v.options[k] === selected[k]; });
    });
    if (match) {
      variantInput.value = match.id;
      var priceEl = section.querySelector('[data-kb-base-price]');
      if (priceEl) priceEl.textContent = match.price_formatted;
      var cta = section.querySelector('[data-kb-cta]');
      if (cta) {
        if (match.available) {
          cta.disabled = false;
          var span = cta.querySelector('[data-kb-cta-label]');
          if (span) span.textContent = cta.dataset.labelAvailable || 'הוסיפו לסל';
        } else {
          cta.disabled = true;
          var span2 = cta.querySelector('[data-kb-cta-label]');
          if (span2) span2.textContent = cta.dataset.labelSoldOut || 'אזל מהמלאי';
        }
      }
    }
    updateTotal(section);
  }

  function updateTotal(section) {
    var form = section.querySelector('[data-kb-configurator]');
    if (!form) return;
    var dataEl = section.querySelector('[data-kb-variants]');
    var variantInput = form.querySelector('input[name="id"]');
    if (!dataEl || !variantInput) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var v = variants.find(function (x) { return String(x.id) === String(variantInput.value); });
    if (!v) return;
    var qty = parseInt((form.querySelector('[data-kb-qty]') || {}).value || '1', 10);
    var totalCents = v.price * qty;
    var totalEl = section.querySelector('[data-kb-total]');
    if (totalEl) {
      var formatted = (totalCents / 100).toFixed(0);
      var currency = section.dataset.currencySymbol || '₪';
      totalEl.textContent = currency + formatted;
    }
  }

  /* ------------------------------------------------------------------
     7) Cart upsell — one-click add inside cart drawer
  ------------------------------------------------------------------ */
  function initUpsell() {
    var btns = document.querySelectorAll('[data-kb-upsell-add]:not([data-kb-bound])');
    btns.forEach(function (btn) {
      btn.setAttribute('data-kb-bound', '1');
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        btn.disabled = true;
        btn.classList.add('kb-upsell__btn--loading');

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Add failed: ' + r.status);
            return r.json();
          })
          .then(function (data) {
            if (data.sections && data.sections['cart-drawer']) {
              var drawerEl = document.querySelector('cart-drawer');
              if (drawerEl) {
                var doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
                var newDrawer = doc.querySelector('cart-drawer');
                if (newDrawer) {
                  drawerEl.innerHTML = newDrawer.innerHTML;
                  drawerEl.classList.remove('is-empty');
                  initUpsell();
                  if (typeof drawerEl.getSectionsToRender === 'function') {
                    drawerEl.dispatchEvent(new CustomEvent('cart:refresh'));
                  }
                }
              }
            }
            if (data.sections && data.sections['cart-icon-bubble']) {
              var bubble = document.getElementById('cart-icon-bubble');
              if (bubble) {
                var bDoc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
                var first = bDoc.body.firstElementChild;
                if (first) bubble.innerHTML = first.innerHTML;
              }
            }
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            }
          })
          .catch(function (err) {
            console.error('[kb-upsell] Add failed:', err);
            btn.disabled = false;
            btn.classList.remove('kb-upsell__btn--loading');
          });
      });
    });
  }

  /* ------------------------------------------------------------------
     8) Multi-image upload (up to 3 slots, validation, progressive reveal)
  ------------------------------------------------------------------ */
  function initMultiUpload(section) {
    var container = section.querySelector('[data-kb-multi]');
    if (!container) return;

    var maxFiles = parseInt(container.dataset.maxFiles || '3', 10);
    var slots = Array.prototype.slice.call(container.querySelectorAll('[data-kb-multi-slot]'));
    var errorEl = container.querySelector('[data-kb-multi-error]');

    var MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
      clearTimeout(errorEl._kbTimer);
      errorEl._kbTimer = setTimeout(function () {
        errorEl.hidden = true;
      }, 5000);
    }
    function clearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    function refreshVisibility() {
      var lastFilled = -1;
      slots.forEach(function (slot, idx) {
        if (idx >= maxFiles) return;
        var input = slot.querySelector('[data-kb-multi-input]');
        if (input && input.files && input.files.length > 0) lastFilled = idx;
      });
      slots.forEach(function (slot, idx) {
        if (idx >= maxFiles) {
          slot.classList.add('kb-multi__slot--disabled');
          slot.classList.add('kb-multi__slot--hidden');
          return;
        }
        var shouldShow = (idx <= lastFilled + 1);
        slot.classList.toggle('kb-multi__slot--hidden', !shouldShow);
      });
    }

    slots.forEach(function (slot) {
      var input = slot.querySelector('[data-kb-multi-input]');
      var placeholder = slot.querySelector('[data-kb-multi-placeholder]');
      var preview = slot.querySelector('[data-kb-multi-preview]');
      var previewImg = preview ? preview.querySelector('img') : null;
      var removeBtn = slot.querySelector('[data-kb-multi-remove]');

      if (!input) return;

      input.addEventListener('change', function (ev) {
        var file = ev.target.files && ev.target.files[0];
        if (!file) return;

        if (!/^image\//i.test(file.type)) {
          showError('יש להעלות תמונה בלבד (JPG / PNG / HEIC / WebP)');
          input.value = '';
          return;
        }
        if (file.size > MAX_SIZE_BYTES) {
          showError('התמונה גדולה מדי. הגודל המקסימלי הוא 10MB');
          input.value = '';
          return;
        }

        clearError();

        var reader = new FileReader();
        reader.onload = function (e) {
          if (previewImg) {
            previewImg.src = e.target.result;
            previewImg.alt = file.name;
          }
        };
        reader.readAsDataURL(file);

        slot.classList.add('kb-multi__slot--has-file');
        if (placeholder) placeholder.hidden = true;
        if (preview) preview.hidden = false;

        refreshVisibility();
      });

      if (removeBtn) {
        removeBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          input.value = '';
          if (previewImg) previewImg.src = '';
          slot.classList.remove('kb-multi__slot--has-file');
          if (preview) preview.hidden = true;
          if (placeholder) placeholder.hidden = false;
          clearError();
          refreshVisibility();
        });
      }
    });

    refreshVisibility();
  }

  /* ------------------------------------------------------------------
     9) Urgency badge — live countdown to next dispatch day
         Updates every minute. Hebrew day names. RTL-aware.
  ------------------------------------------------------------------ */
  var KB_HEBREW_DAYS = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];

  function formatHebrewTime(hours, minutes) {
    if (hours <= 0 && minutes <= 0) return 'דקה';
    if (hours <= 0) {
      if (minutes === 1) return 'דקה';
      if (minutes === 2) return 'שתי דקות';
      return minutes + ' דקות';
    }
    var hourPart;
    if (hours === 1) hourPart = 'שעה';
    else if (hours === 2) hourPart = 'שעתיים';
    else hourPart = hours + ' שעות';

    if (minutes <= 0) return hourPart;
    if (minutes === 1) return hourPart + ' ודקה';
    if (minutes === 2) return hourPart + ' ושתי דקות';
    return hourPart + ' ו-' + minutes + ' דקות';
  }

  function initUrgency(section) {
    var el = section.querySelector('[data-kb-urgency]');
    if (!el) return;

    var cutoffHour = parseInt(el.dataset.cutoffHour || '14', 10);
    var cutoffMinute = parseInt(el.dataset.cutoffMinute || '0', 10);
    var template = el.dataset.template || '';
    var textEl = el.querySelector('[data-kb-urgency-text]');
    var dispatchDays = (el.dataset.dispatchDays || '')
      .split(',')
      .map(function (d) { return parseInt(d, 10); })
      .filter(function (d) { return !isNaN(d) && d >= 0 && d <= 6; });

    if (!textEl || !template || !dispatchDays.length) return;

    function tick() {
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(cutoffHour, cutoffMinute, 0, 0);

      var cutoffPassed = cutoff <= now;
      if (cutoffPassed) {
        cutoff.setDate(cutoff.getDate() + 1);
        cutoff.setHours(cutoffHour, cutoffMinute, 0, 0);
      }

      var msRemaining = cutoff - now;
      var hoursRemaining = Math.floor(msRemaining / 3600000);
      var minutesRemaining = Math.floor((msRemaining % 3600000) / 60000);

      // Find next dispatch day (starting from cutoff date)
      var shipDate = new Date(cutoff);
      shipDate.setHours(0, 0, 0, 0);
      var maxLoop = 8;
      while (maxLoop-- > 0) {
        if (dispatchDays.indexOf(shipDate.getDay()) !== -1) break;
        shipDate.setDate(shipDate.getDate() + 1);
      }

      var todayMid = new Date(now);
      todayMid.setHours(0, 0, 0, 0);
      var dayDiff = Math.round((shipDate - todayMid) / 86400000);

      var dayLabel;
      if (dayDiff === 0) dayLabel = 'היום';
      else if (dayDiff === 1) dayLabel = 'מחר';
      else dayLabel = 'יום ' + KB_HEBREW_DAYS[shipDate.getDay()] + ' הקרוב';

      var timeStr = formatHebrewTime(hoursRemaining, minutesRemaining);

      var text = template
        .replace('{HOURS}', timeStr)
        .replace('{DAY}', dayLabel);

      textEl.textContent = text;
    }

    tick();
    // Update every minute
    if (el._kbTimer) clearInterval(el._kbTimer);
    el._kbTimer = setInterval(tick, 60000);
  }

  /* ------------------------------------------------------------------
     Boot
  ------------------------------------------------------------------ */
  function boot() {
    initFadeIn();
    document.querySelectorAll('[data-kb-hero]').forEach(initHero);
    document.querySelectorAll('[data-kb-scroller]').forEach(initScroller);
    document.querySelectorAll('[data-kb-testimonials]').forEach(initTestimonials);
    document.querySelectorAll('[data-kb-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-kb-product]').forEach(function (section) {
      initConfigurator(section);
      initMultiUpload(section);
      initUrgency(section);
    });
    initUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', boot);
})();
